import { apiClient } from "./client";

export interface CodeRef {
  kind?: string;
  vcs?: string;
  provider?: string;
  repository?: {
    provider?: string;
    owner?: string;
    name?: string;
    url?: string;
  };
  commit?: string;
  branch?: string;
  relative_path?: string;
  line_number?: number;
  line_hash_sha256?: string;
  file_hash_sha256?: string;
  dirty?: boolean;
  dirty_status?: string;
  dirty_diff_hash_sha256?: string;
  url?: string;
  commit_url?: string;
}

export interface CodeSource {
  provider: string;
  repository: {
    owner: string;
    name: string;
    url?: string;
  };
  ref: string;
  path: string;
  filename: string;
  language: string;
  line_number?: number | null;
  url?: string | null;
  commit_url?: string | null;
  content: string;
  line_count: number;
  truncated: boolean;
}

export function extractCodeRef(metadata: Record<string, unknown> | undefined | null): CodeRef | null {
  const raw = metadata?.code_ref;
  if (!raw || typeof raw !== "object") return null;
  const ref = raw as CodeRef;
  if (ref.provider !== "github" || !ref.repository?.owner || !ref.repository?.name || !ref.relative_path) {
    return null;
  }
  return ref;
}

export async function fetchCodeSource(projectId: string, codeRef: CodeRef): Promise<CodeSource> {
  return apiClient<CodeSource>("/code/source", {
    method: "POST",
    body: {
      project_id: projectId,
      code_ref: codeRef,
    },
  });
}
